import { MODAL_SIZES, Modal } from 'ui/modal';
import { useModalContext } from 'utils/contexts/modal';
import { HYPERLINK_MODAL_ID } from '../constants';
import { HyperlinkFormProvider } from './contexts/hyperlinkForm';
import { Header } from './components/Header';
import { Footer } from './components/footer';
import { Body } from './components/body';

export const HyperlinkModal = () => {
  const { hideModal, modalState } = useModalContext();
  const isShowingHyperlinkModal = modalState === HYPERLINK_MODAL_ID;
  if (!isShowingHyperlinkModal) return <></>;
  return (
    <HyperlinkFormProvider>
      <Modal
        id={HYPERLINK_MODAL_ID}
        isModalOpen
        onClose={hideModal}
        size={MODAL_SIZES.MEDIUM}
        data-test="hyperlink-modal"
      >
        <Header />
        <Body />
        <Footer />
      </Modal>
    </HyperlinkFormProvider>
  );
};
